module.exports = __webpack_public_path__ + "img/ouraim.54f18648.png";